import axios, { Axios } from 'axios';
import {
  IIndustryListResDto,
  IRegistrationDtoRes,
  IPhoneCodeChannelResDto,
  IPhoneCodeConfirmBody,
  IPhoneCodeResDto,
  ISelfRegistrationBody,
  ISelfRegistrationResDto,
} from 'components/SelfRegistration/types/dtos';
import { IResponse } from 'services/api/axios';

const selfRegistrationClient: Axios = axios.create({
  baseURL: '/panel-main/api',
});

const langHeader = (lang?: string) => (lang ? { headers: { 'X-Lang': lang } } : undefined);

export const selfRegistrationService = {
  sendPhoneCode: (body: IRegistrationDtoRes, lang?: string) => selfRegistrationClient
    .post<IPhoneCodeResDto>('v2/self-registration/phone-code', body, langHeader(lang)),

  getPhoneCodeChannel: () => selfRegistrationClient
    .get<IPhoneCodeChannelResDto>('v2/self-registration/phone-code/channel'),

  confirmPhoneCode: (body: IPhoneCodeConfirmBody, lang?: string) => selfRegistrationClient
    .post<IResponse>('v2/self-registration/phone-code/confirm', body, langHeader(lang)),

  register: (body: ISelfRegistrationBody, lang?: string) => selfRegistrationClient
    .post<ISelfRegistrationResDto>('v2/self-registration', body, langHeader(lang)),

  getIndustries: () => selfRegistrationClient
    .get<IIndustryListResDto>('v2/self-registration/industries'),
};

export default selfRegistrationClient;
